import axios from 'axios'
import authentication from '/src/features/auth/tasks/authentication'
import token from '/src/features/auth/tasks/token'
import router from '../router'

export class Provider {
  constructor() {
    this.options = {
      headers: {
        'Content-Type': 'application/json',
        // 'Content-Type': 'text/plain',
        'Accept': 'application/json',
        //     'Access-Control-Max-Age': 600
      }
    }
  }

  doRequest(type, url, payload = null) {
    this.options.headers.Authorization = authentication.getToken()
    return new Promise((resolve, reject) => {
      let request = null

      switch (type.toUpperCase()) {
        case 'GET':
          request = axios.get(url, this.options)
          break
        case 'POST':
          request = axios.post(url, payload, this.options)
          break
        case 'DELETE':
          request = axios.delete(url, this.options)
          break
        case 'PUT':
          request = axios.put(url, payload, this.options)
          break
        case 'PATCH':
          // this.options.headers['Content-Type'] = 'application/x-www-form-urlencoded'
          // this.options.data = qs.stringify(payload)
          // this.url = url
          // this.method = 'PATCH'
          // request = axios(this.options)
          request = axios.patch(url, payload, this.options)
          break
      }

      request
        .then(res => {
          resolve(res.data)
        })
        .catch(e => {
          // console.log(e)

          if (e.message === 'Network Error') {
            // console.log('There was a network error.');
            // authentication.logout()
            reject(e)

            return;
          }

          // If Token it's not authorized
          if (e.response.status === 401 && router.currentRoute.path !== '/login') {
            // If even Refresh Token are not valid anymore
            if (!e.response.data.errors) {
              authentication.logout()
              return
            }
            // Try to get a new Token through Refresh Token
            token.getRefreshToken()
              // Retry the request if has a new Token
              .then(() => {
                this.doRequest(type, url, payload)
                  .then(res => {
                    resolve(res)
                  })
              })
          } else {
            reject(e)
          }
        })
    })
  }
}
